import { Component } from '../Component';
import { ArgSpecDictionary } from '../ComponentUtils';

import svgArrowLeft from './ArrowLeft.svg?raw';
import svgArrowRight from './ArrowRight.svg?raw';

const DEBUG_VERBOSE: boolean = false;
export const HHDSButtonPaginationTagName: string = 'hhds-button-pagination';
const TAG_NAME: string = HHDSButtonPaginationTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export const HHDSButtonPaginationAttrNames = {
	Direction: 'direction',
};

export enum HHDSButtonPaginationDirection {
	Previous = 'previous',
	Next = 'next',
}

const Attrs = HHDSButtonPaginationAttrNames;

export class HHDSButtonPagination extends Component {
	constructor() {
		super();
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');

		const html: string = /* html */ `
      <button class="${TAG_NAME}" ${this.attributeAriaLabel}>${this.markupSVG}</button>
    `;

		// Helper/tidiness method for defining this.shadow.innerHTML with
		// global styles and component styles prefixed to the supplied HTML.
		// Using this universally would ensure that we can easily alter this
		// structure across all components.
		this.setInnerHtml('', '', html);

		this.observeSlotChanges(true);
	}

	get attributeAriaLabel() {
		const attrDirection = this.vars.get<HHDSButtonPaginationDirection>(Attrs.Direction);

		return `aria-label="${attrDirection} slide"`;
	}

	get markupSVG() {
		const attrDirection = this.vars.get<HHDSButtonPaginationDirection>(Attrs.Direction);

		if (attrDirection === HHDSButtonPaginationDirection.Next) {
			return svgArrowRight;
		} else {
			return svgArrowLeft;
		}
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'destroy');
	}

	override onAttributeChanged(name: string, _oldValue: string, _newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onAttributeChanged: ${name}`);
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, _elements: HTMLElement[]): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onSlotChange`);
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {
	[Attrs.Direction]: {
		description: 'Arrow direction next/previous',
		defaultValue: HHDSButtonPaginationDirection.Next,
		type: HHDSButtonPaginationDirection,
	},
};
